import type { PlanTiers } from "@/react/helpers/planHelpers";
import {
  getNextTier,
  isPlanEnterprise,
  isPlanProfessional,
} from "@/react/helpers/planHelpers";
import type { CurrentPlan, Plan } from "@circle-react/types";

interface GetDefaultPlanTierParams {
  currentPlan?: CurrentPlan;
  isCommunityOnPaidPlan: boolean;
  isCommunityOnTrial: boolean;
  isExpiredTrial: boolean;
  plans: Plan[];
}

export const getDefaultPlanTier = ({
  plans,
  currentPlan,
  isCommunityOnTrial,
  isExpiredTrial,
  isCommunityOnPaidPlan,
}: GetDefaultPlanTierParams): PlanTiers | undefined => {
  if (!plans.length) return undefined;

  const renewPlan = plans.find(plan => plan.plan_action === "renew");
  if (renewPlan) return renewPlan.tier;

  if (currentPlan && currentPlan.tier === "enterprise") {
    return currentPlan.tier;
  }

  if (isCommunityOnTrial || isExpiredTrial) {
    const professionalPlan = plans.find(plan => isPlanProfessional(plan.tier));
    if (professionalPlan) return professionalPlan.tier;
  }

  if (
    isCommunityOnPaidPlan &&
    currentPlan &&
    !isPlanEnterprise(currentPlan.tier)
  ) {
    const nextTierPlan = plans.find(
      plan => plan.tier === getNextTier(currentPlan.tier),
    );
    if (nextTierPlan) return nextTierPlan.tier;
  }

  return undefined;
};
